import Urls from './../Common/Urls';
const Constants = require('./../Common/Constants');

export function getOperatorCount(token, environment) {
  var url = '';
  if (environment === Constants.TestEnv) url = Urls.getOperatorCountTest;
  else if (environment === Constants.StagingEnv) url = Urls.getOperatorCountStaging;
  else if (environment === Constants.ProdEnv) url = Urls.getOperatorCountProd;
  else throw Error('Not implemented ');

  var operatorFilterBody = {
    tenant: 'tofino',
  };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ClientId: 'TRMSDevClientId',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(operatorFilterBody),
  }).then(response => {
    //alert(response.statusText );
    return response;
  });
}
